import { Box, List, Typography } from '@mui/material'
import { IconX } from '@tabler/icons-react'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import EmptyScreen from '../../../../components/EmptyScreen'
import { useAppSelector } from '../../../../store'
import {
  selectStartDate,
  selectValidVisitorsTotalCount,
  selectVisitorsEaters,
} from '../../../../store/restaurant/dashboard'
import VisitorUserDetail from './visitors/VisitorUserDetail'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import VisitorAction from './visitors/VisitorAction'

interface VisitorsModalProps {
  handleClose?: () => void
}

const VisitorsModal: React.FC<VisitorsModalProps> = ({ handleClose }) => {
  const visitors = useAppSelector(selectVisitorsEaters)
  const visitorCount = useAppSelector(selectValidVisitorsTotalCount)
  const fromDate = useAppSelector(selectStartDate)
  const { isMediumScreen } = useAppUtilities()
  const [data, setDate] = useState<string>('')

  useEffect(() => {
    void onDateInit()
  }, [fromDate])

  const onDateInit = async (): Promise<void> => {
    if (dayjs(fromDate).isSame(dayjs().subtract(1, 'day'), 'day')) {
      setDate('From Yesterday')
    } else {
      setDate(`From ${dayjs(fromDate).format('D MMM, YYYY')}`)
    }
  }

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Typography variant="h4">Visitors ({visitorCount})</Typography>
          <Typography color="grey.400" variant="subtitle1">
            {data}
          </Typography>
        </Box>
        <Box
          sx={{
            cursor: 'pointer',
            '&:hover': { color: 'grey.700' },
          }}
          onClick={handleClose}
          color="grey.500"
        >
          <IconX stroke={2} />
        </Box>
      </Box>
      <List
        sx={{
          maxHeight: 500,
          overflow: 'auto',
        }}
      >
        {visitors && visitors?.length > 0 ? (
          visitors?.map((visitor, index) => (
            <React.Fragment key={index}>
              {!isMediumScreen ? (
                <VisitorUserDetail
                  visitor={visitor}
                  key={index}
                  secondaryAction={
                    !isMediumScreen ? (
                      <VisitorAction visitor={visitor} key={index} />
                    ) : (
                      <></>
                    )
                  }
                />
              ) : (
                <Box key={index}>
                  <VisitorUserDetail visitor={visitor} />
                  <VisitorAction visitor={visitor} key={index} />
                </Box>
              )}
            </React.Fragment>
          ))
        ) : (
          <EmptyScreen
            mainText="No data available"
            secondaryText="No visitor data found"
            imageUrl="/images/empty-screen.svg"
            containerHeight={'400px'}
          />
        )}
      </List>
    </Box>
  )
}

export default VisitorsModal
